/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Hide_Page_BreaksInputs */



/**
* | output |
* | --- |
* | "Hide page breaks" |
*
* @param {Editor_Hide_Page_BreaksInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_hide_page_breaks = /** @type {((inputs?: Editor_Hide_Page_BreaksInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Hide_Page_BreaksInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Seitenumbrüche ausblenden")
	return /** @type {LocalizedString} */ ("Hide page breaks")
});